import React from 'react';
import FloatingMenuOption from './FloatingMenuOption';

const PlaceholderFloatingMenu = () => {
    return (
        <>
            <FloatingMenuOption.PlaceholderEdit />
            <FloatingMenuOption.RotateRight />
            <FloatingMenuOption.Movement />
            <FloatingMenuOption.PlaceholderDuplicate />
            <FloatingMenuOption.PlaceholderDelete />
        </>
    );
};

export default PlaceholderFloatingMenu;
